import AutorizacoesIndexPage from "@/Pages/Autorizacoes/Solicitante/index.vue";
import NewEditAutorizacaoPage from "@/Pages/Autorizacoes/Solicitante/NewEditAutorizacaoPage.vue";
import store from "@/store";
import autorizacoesService from "@/Services/AutorizacoesService";

async function verificarAcessoAutorizacoes(to, from, next) {
  const user = store.getters["Auth/user"];
  const role = user?.roleName;

  if (["super-admin", "professor", "prof-auxiliar"].includes(role)) {
    return next();
  }

  if (role === "admin") {
    try {
      const response = await autorizacoesService.getUsuarioTi();
      if (response.data?.id === user.id) {
        return next();
      }
    } catch (error) {
      // sem acesso ao usuário de TI: segue para o bloqueio
    }
  }

  return next({ name: "NaoAutorizado" });
}

export default [
  {
    path: "/autorizacoes/",
    name: "autorizacoes",
    component: AutorizacoesIndexPage,
    beforeEnter: verificarAcessoAutorizacoes,
  },
  {
    path: "/autorizacoes/create/:etapa",
    name: "autorizacoes.create",
    component: NewEditAutorizacaoPage,
    props: { editing: false },
    beforeEnter: verificarAcessoAutorizacoes,
  },
  {
    path: "/autorizacoes/edit/:autorizacao_id",
    name: "autorizacoes.edit",
    component: NewEditAutorizacaoPage,
    props: { editing: true },
    beforeEnter: verificarAcessoAutorizacoes,
  },
];
